import { get, sortBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOptions = get('POS.options');

export const getPosLocation = createSelector(getOptions, get('location'));

export const getPosLocationOptions = createSelector(
  getPosLocation,
  get('options')
);

export const getSortedPosLocationOptions = createSelector(
  getPosLocationOptions,
  sortBy('label')
);

export const getIsFetchingPosLocationOptions = createSelector(
  getPosLocation,
  get('fetching')
);

export const getIsFetchedPosLocationOptions = createSelector(
  getPosLocation,
  get('fetched')
);
